import { render, staticRenderFns } from "./FollowUpPlanManagement.vue?vue&type=template&id=106bd628&scoped=true"
import script from "./FollowUpPlanManagement.vue?vue&type=script&lang=js"
export * from "./FollowUpPlanManagement.vue?vue&type=script&lang=js"
import style0 from "./FollowUpPlanManagement.vue?vue&type=style&index=0&id=106bd628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106bd628",
  null
  
)

export default component.exports